// Extension allowlists for segment attachment uploads. Each one mirrors a
// DirectUpload::Purpose on the server, which is the gate. These run first so
// the picker can reject a file before it is read.

/**
 * The broad list, used by team-discussion attachments and anything else that
 * is not routed to the AI feedback Lambda. Mirrors the Rails constant
 * `ContentLibrary::DocumentAllowList::EXTENSIONS`.
 */
export const acceptedFileExtensions = [
  'doc',
  'docx',
  'xls',
  'xlsx',
  'csv',
  'zip',
  'pdf',
  'ppt',
  'pptx',
  'pwptx',
  'odt',
  'pages',
  'rtf',
  'pps',
  'jpg',
  'jpeg',
  'gif',
  'png',
  'vsd',
  'vsdx',
  'vdx',
  'vss',
  'vsx',
  'vst',
  'vtx',
];

export type AcceptedFileExtensions = (typeof acceptedFileExtensions)[number];

// Subset of acceptedFileExtensions that the AI feedback Lambda can process.
// Source of truth is the Rails constant
// `ContentLibrary::AiFeedbackAllowList::EXTENSIONS`, which in turn mirrors the
// Lambda's CONVERTIBLE_EXTENSIONS + PASSTHROUGH_EXTENSIONS in the
// submission-adapter-lambda repo's file_converter.py. Keep these in sync.
export const aiFeedbackAcceptedExtensions = [
  'pdf',
  'docx',
  'doc',
  'pptx',
  'ppt',
  'xlsx',
  'xls',
  'png',
  'jpg',
  'jpeg',
];
